import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface MoralEventChoice {
  text: string;
  effects: {
    time?: number;
    morality?: number;
    aiPower?: number;
    trustLevel?: number;
  };
  aiComment?: string;
}

interface MoralChoiceModalProps {
  moralEvent: {
    id: string;
    triggerLevel: number;
    title: string;
    description: string;
    choices: MoralEventChoice[];
  } | null;
  onChoice: (choice: MoralEventChoice) => void;
}

export const MoralChoiceModal: React.FC<MoralChoiceModalProps> = ({ moralEvent, onChoice }) => {
  return (
    <AnimatePresence>
      {moralEvent && (
        <motion.div
          className="chapter-overlay" // Reusing styles from StoryChapterModal
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <motion.div
            className="chapter-modal" // Reusing styles
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            <div className="chapter-header">
              <h2 className="chapter-title text-yellow-400">{moralEvent.title}</h2>
            </div>
            <div className="chapter-content">
              <p className="chapter-text">{moralEvent.description}</p>
            </div>
            <div className="flex flex-col items-center gap-4 w-full">
              {moralEvent.choices.map((choice, index) => (
                <button
                  key={index}
                  className="chapter-continue-btn w-full" // Reusing styles
                  onClick={() => onChoice(choice)}
                >
                  {choice.text}
                </button>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
